"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiftCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const router_1 = require("next/router");
const link_1 = __importDefault(require("next/link"));
const hooks_1 = require("../hooks");
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("../styles");
const TRANSLATIONS_GIFT_CARD = {
    'es-ES': {
        name: 'Tarjeta Regalo',
        title: 'El mejor regalo para estas navidades',
        cta: 'Consigue tu targeta regalo'
    },
    'en-EU': {
        name: 'Gift Card',
        title: 'The best gift for Christmas',
        cta: 'Get your gift card'
    },
    'fr-FR': {
        name: 'Carte cadeau',
        title: 'Le meilleur cadeau pour Noël',
        cta: 'Recevez votre carte cadeau'
    },
    'en-GB': {
        name: 'Gift Card',
        title: 'The best gift for Christmas',
        cta: 'Get your gift card'
    },
    'de-DE': {
        'brand': 'brand'
    },
    'es-MD': {
        name: 'Tarjeta Regalo',
        title: 'El mejor regalo para estas navidades',
        cta: 'Consigue tu targeta regalo'
    },
    'es-CN': {
        name: 'Tarjeta Regalo',
        title: 'El mejor regalo para estas navidades',
        cta: 'Consigue tu targeta regalo'
    },
    'es-CT': {
        name: 'Tarjeta Regalo',
        title: 'El mejor regalo para estas navidades',
        cta: 'Consigue tu targeta regalo'
    },
    'pt-PT': {
        name: 'Cartão Presente',
        title: 'O melhor presente para este Natal',
        cta: 'Obtenha o seu cartão presente'
    }
};
exports.GiftCard = (0, react_1.memo)(({ data, onClick, narrow = false }) => {
    const { locale } = (0, router_1.useRouter)();
    // const { cardClicked } = useActiveVariant()
    const { ref } = (0, hooks_1.useInView)({
        rootMargin: '0px',
        threshold: 0,
        triggerOnce: true,
    });
    console.log('data', data);
    return ((0, jsx_runtime_1.jsx)(link_1.default, Object.assign({ href: '/' }, { children: (0, jsx_runtime_1.jsx)(Article, Object.assign({ ref: ref, className: `gift-card ${true ? ' selected' : ''}`, narrow: narrow, onClick: () => { onClick; } }, { children: (0, jsx_runtime_1.jsxs)(TextWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("span", { children: [" ", TRANSLATIONS_GIFT_CARD[locale].name] }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: 'gift' }, { children: TRANSLATIONS_GIFT_CARD[locale].title }))] }), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: 'cta' }, { children: [TRANSLATIONS_GIFT_CARD[locale].cta, (0, jsx_runtime_1.jsx)("img", { src: '/images/svg/arrow-right.svg', alt: 'Arrow right', width: '15', height: '13' })] }))] }) })) })));
});
const Article = styled_components_1.default.article `
  background: url('/images/svg/gift-card-mobile.svg');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 20px;
  box-shadow: 2px 2px 4px ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.black, .4)};
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.basier};
  height: ${(0, styles_1.vw)(270, 'mobile')};
  margin-right: ${(0, styles_1.vw)(5, 'mobile')};
  overflow: hidden;
  position: relative;
  transition: 200ms all ${({ ease }) => ease};
  transform: rotate(-0.5deg);
  scale: 0.9;
  width: ${(0, styles_1.vw)(350, 'mobile')};
  z-index: 20;

  &.selected,
  &:hover {
    border-color: ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.darkred, .6)};
    box-shadow: 2px 2px 8px ${({ theme }) => (0, styles_1.hex2Rgba)(theme.colors.black, .4)};
    transform: rotate(1deg) scale(1.02);
  }

  &:not(.selected) {
    &:hover {
      .cta {
        transform: translateX(${(0, styles_1.vw)(10, 'mobile')});

        ${styles_1.mq.greaterThan('nexus7')} {
          transform: translateX(${(0, styles_1.vw)(10, 'nexus7')});
        }

        ${styles_1.mq.greaterThan('tablet')} {
          transform: translateX(${(0, styles_1.vw)(10, 'desktop')});
        }

        ${styles_1.mq.greaterThan('desktop')} {
          transform: translateX(10px);
        }
      }
    }
  }

  &.selected {
    ${styles_1.mq.greaterThan('tablet')} {
      background-position: top;
      width: ${(0, styles_1.vw)(386, 'desktop')}
    }
  }

  ${styles_1.mq.greaterThan('nexus7')} {
    background: url('/images/svg/gift-card.svg');
    background-size: cover;
    height: ${(0, styles_1.vw)(277, 'nexus7')};
    width: ${(0, styles_1.vw)(350, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    background: url('/images/svg/gift-card.svg');
    background-size: cover;
    height: ${(0, styles_1.vw)(360, 'desktop')};
    margin-right: ${(0, styles_1.vw)(5, 'desktop')};
    width: ${({ narrow }) => narrow ? `${(0, styles_1.vw)(386, 'desktop')}` : `${(0, styles_1.vw)(440, 'desktop')}`};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    background: url('/images/svg/gift-card.svg');
    background-size: cover;
    height: 360px;
    margin-right: 5px;
    width: ${({ narrow }) => narrow ? '385px' : '440px'};
  }
`;
const TextWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: ${(0, styles_1.vw)(20, 'mobile')} ${(0, styles_1.vw)(40, 'mobile')} ${(0, styles_1.vw)(20, 'mobile')} ${(0, styles_1.vw)(20, 'mobile')};
  text-align: left;

  ${styles_1.mq.greaterThan('nexus7')} {
    padding: ${(0, styles_1.vw)(20, 'nexus7')} ${(0, styles_1.vw)(40, 'nexus7')} ${(0, styles_1.vw)(20, 'nexus7')} ${(0, styles_1.vw)(20, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    padding: ${(0, styles_1.vw)(40, 'desktop')} ${(0, styles_1.vw)(80, 'desktop')} ${(0, styles_1.vw)(40, 'desktop')} ${(0, styles_1.vw)(40, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    padding:40px 80px 40px 40px;
  }

  span {
    display: block;
  }

  .gift {
    ${(0, styles_1.getP45)()}
    text-align: left;
    margin: ${(0, styles_1.vw)(15, 'mobile')} 0 ${(0, styles_1.vw)(60, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin: ${(0, styles_1.vw)(15, 'nexus7')} 0 ${(0, styles_1.vw)(60, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin: ${(0, styles_1.vw)(15, 'desktop')} 0 ${(0, styles_1.vw)(80, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin: 15px 35px 80px 0;
    }
  }

  .cta {
    ${(0, styles_1.getP15_1B)()}
    color: ${({ theme }) => theme.colors.creamlight};
    transition: 300ms transform ease-out;

    img {
      margin-left: 5px;
      width: unset;
    }
  }
`;
